export default __webpack_public_path__ + "static/media/ic-info.98b8106a.svg";